import * as React from 'react';

import { Dropdown } from 'semantic-ui-react';

import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';
import { isdeviceUpToTablet, isMobile } from '../../../shared/helpers/responsive';

import './EditorNewTab.scss';
import { FormattedMessageHelper } from '../../../shared/helpers/internationalization';

interface EditorNewTabProps {
  isChild: boolean;
  disable?: boolean;
  handleNewTab: () => void;
  handleNewMultiTab: () => void;
  handleNewChildTab?: () => void;
  hasPermission?: boolean;
  hasSuperAlphaPermission: boolean;
  handleNewSuperAlpha: () => void;
  modifiers?: string[];
  numberOfTabs: number;
}

class EditorNewTab extends React.Component<EditorNewTabProps> {
  state = { isMobile: isMobile('mobile') };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateMobileState);
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateMobileState);
  }

  updateMobileState = () => {
    this.setState({ isMobile: isMobile('mobile') });
  };

  render() {
    const {
      isChild,
      disable,
      handleNewTab,
      handleNewMultiTab,
      handleNewChildTab,
      hasPermission,
      hasSuperAlphaPermission,
      handleNewSuperAlpha,
      numberOfTabs,
    } = this.props;
    let { modifiers } = this.props;

    if (modifiers && disable) {
      modifiers.push('disabled');
    } else if (disable) {
      modifiers = ['disabled'];
    }

    return (
      <div className={addModifiers('editor-tabs__new-tab-element', modifiers)}>
        {isChild && !this.state.isMobile ? (
          <div onClick={!disable ? handleNewChildTab : undefined} className="editor-tabs__new-tab-dropdown-element">
            <span className="editor-tabs__new-tab-icon">+</span>
          </div>
        ) : (!hasPermission && !hasSuperAlphaPermission) || this.state.isMobile ? (
          <div onClick={handleNewTab} className="editor-tabs__new-tab-dropdown-element">
            <div className="editor-tabs__new-tab-dropdown-element__button">
              <span className="editor-tabs__new-tab-icon">+</span>
            </div>
          </div>
        ) : (
          <Dropdown
            icon={null}
            trigger={
              <div className="editor-tabs__new-tab-dropdown-element">
                <div className="editor-tabs__new-tab-dropdown-element__button">
                  <span className="editor-tabs__new-tab-icon">+</span>
                </div>
              </div>
            }
            className="editor-tabs__new-tab-dropdown"
          >
            <Dropdown.Menu className={isdeviceUpToTablet() && numberOfTabs > 0 ? 'left' : ''}>
              <Dropdown.Item onClick={handleNewTab}>
                <div className="editor-tabs__new-tab-dropdown-element__option">
                  <span className="editor-tabs__new-tab-icon">&#43;</span>
                  <span className="editor-tabs__new-tab-text">
                    <FormattedMessageHelper
                      tagName="span"
                      id="editorNewTab.newSingleSimulation"
                      defaultMessage={localeData.en['editorNewTab.newSingleSimulation']}
                    />
                  </span>
                </div>
              </Dropdown.Item>
              {hasPermission && (
                <Dropdown.Item onClick={handleNewMultiTab}>
                  <div className="editor-tabs__new-tab-dropdown-element__option">
                    <span className="editor-tabs__new-tab-icon">&#43;</span>
                    <span className="editor-tabs__new-tab-text">
                      <FormattedMessageHelper
                        tagName="span"
                        id="editorNewTab.newMultiSimulation"
                        defaultMessage={localeData.en['editorNewTab.newMultiSimulation']}
                      />
                    </span>
                  </div>
                </Dropdown.Item>
              )}
              {hasSuperAlphaPermission && (
                <Dropdown.Item onClick={handleNewSuperAlpha}>
                  <div className="editor-tabs__new-tab-dropdown-element__option">
                    <span className="editor-tabs__new-tab-icon">&#43;</span>
                    <span className="editor-tabs__new-tab-text">
                      <FormattedMessageHelper
                        tagName="span"
                        id="editorNewTab.super.alpha"
                        defaultMessage={localeData.en['editorNewTab.super.alpha']}
                      />
                    </span>
                  </div>
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    );
  }
}

export default EditorNewTab;
